<template>
<div id="catalogo_mt" >
    <v-power-catalogo :parametros="parametros" />
</div>
</template>

<script>
import powerCatalogo from "@/views/apendices/layout.vue";
export default {
    components: {
        "v-power-catalogo": powerCatalogo
    },
    mounted() {},

    data: () => ({
        fab: false,
        parametros: {
            url_actions: "apendices/",
            url_list: "apendices/lista/",
            tabla: 16,
            title: "IDENTIFICADORES",
            columns: [
                "clave",
                "descripcion",
                "nivel",
                "supuesto",
                "complemento1",
                "complemento2",
                "complemento3",
                "actions"
            ],
            options: {
                filterable: [
                    "clave",
                    "descripcion",
                    "nivel",
                    "supuesto",
                    "complemento1",
                    "complemento2",
                    "complemento3"
                ],
                sortable: [
                    "clave",
                    "descripcion",
                    "nivel",
                    "supuesto",
                    "complemento1",
                    "complemento2",
                    "complemento3"
                ],

                headings: {
                    clave: "Clave",
                    descripcion: "Descripción",
                    nivel: "Nivel",
                    supuesto: "Supuesto",
                    complemento1: "Complemento1",
                    complemento2: "Complemento2",
                    complemento3: "Complemento3",
                    actions: "Operaciones"
                }
            },
            camposexcel: {
                Clave: "clave",
                Descripción: "descripcion",
                Nivel: "nivel",
                Supuesto: "supuesto",
                Complemento1: "complemento1",
                Complemento2: "complemento2",
                Complemento3: "complemento3"
            },
            encabezadoLayout: {
                clave: "clave",
                descripcion: "descripcion",
                nivel: "nivel",
                supuesto: "supuesto",
                complemento1: "complemento1",
                complemento2: "complemento2",
                complemento3: "complemento3"
            },
            camposLayout: [{
                clave: "[Clave del Identificador]",
                descripcion: "[Descripción del Identificador]",
                nivel: "[Nivel del Identificador]",
                supuesto: "[Supuesto del Identificador]",
                complemento1: "[Complemento1 del Identificador]",
                complemento2: "[Complemento2 del Identificador]",
                complemento3: "[Complemento3 del Identificador]"
            }],
            model: {
                id: 0,
                clave: "",
                descripcion: "",
                nivel: "",
                supuesto: "",
                complemento1: "",
                complemento2: "",
                complemento3: ""
            },
            form: {
                clave: {
                    requiered: true,
                    label: "Clave",
                    value: "",
                    maxlen: 10
                },
                descripcion: {
                    requiered: true,
                    label: "Descripción",
                    value: "",
                    maxlen: 255
                },
                nivel: {
                    requiered: true,
                    label: "Nivel",
                    value: "",
                    maxlen: 100
                },
                supuesto: {
                    requiered: true,
                    label: "Supuesto",
                    value: "",
                    maxlen: 255
                },
                complemento1: {
                    requiered: true,
                    label: "Complemento1",
                    value: "",
                    maxlen: 1555
                },
                complemento2: {
                    requiered: true,
                    label: "Complemento2",
                    value: "",
                    maxlen: 1555
                },
                complemento3: {
                    requiered: true,
                    label: "Complemento3",
                    value: "",
                    maxlen: 1555
                }
            },
            breadcrumbs: [{
                    text: "Inicio",
                    disabled: false,
                    to: "/home"
                },
                {
                    text: "Utilerías",
                    disabled: true,
                    to: ""
                },
                {
                    text: "Apendices",
                    disabled: true,
                    to: ""
                }
            ]
        }
    })
};
</script>
